import Search from "./search"
import Movie from "./movie"
import Person from "./person"
import TV from "./tv"

export default [Search, Movie, Person, TV]
